// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/WixMadeforDisplay/WixMadeforDisplay-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./fonts/WixMadeforDisplay/WixMadeforDisplay-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./fonts/WixMadeforDisplay/WixMadeforDisplay-ExtraBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./fonts/WixMadeforDisplay/WixMadeforDisplay-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./fonts/WixMadeforDisplay/WixMadeforDisplay-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./fonts/WixMadeforText/WixMadeforText-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./fonts/WixMadeforText/WixMadeforText-ExtraBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./fonts/WixMadeforText/WixMadeforText-BoldItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("./fonts/WixMadeforText/WixMadeforText-ExtraBoldItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("./fonts/WixMadeforText/WixMadeforText-Italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("./fonts/WixMadeforText/WixMadeforText-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("./fonts/WixMadeforText/WixMadeforText-MediumItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("./fonts/WixMadeforText/WixMadeforText-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("./fonts/WixMadeforText/WixMadeforText-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("./fonts/WixMadeforText/WixMadeforText-SemiBoldItalic.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Wix+Madefor+Display);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  scroll-behavior: smooth;
  box-sizing: border-box;
  letter-spacing: 1px; /* originally 2.4px */
}

p {
  line-height: 2rem;
}
#root {
  overflow-x: hidden;
}

:root {
  --primary-color: #ff8335;
  --secondary-color: #006d77;
  --tertiary-color: #83c5be;
  --light-primary-color: white;
  --dark-primary-color: #3d3d3d;
  --text-color: black;
  --tablet-width: 768px;
  --mobile-width: 425px;
}

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: white;
  font-family: "Wix Made For Display";
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace;
}

/* buttons */

.button {
  appearance: none;
  background-color: #fafbfc;
  border: 1px solid rgba(27, 31, 35, 0.15);
  border-radius: 6px;
  box-shadow: rgba(27, 31, 35, 0.04) 0 1px 0, rgba(255, 255, 255, 0.25) 0 1px 0 inset;
  box-sizing: border-box;
  color: black;
  cursor: pointer;
  display: inline-block;
  font-family: "WMFD-Bold";
  font-size: 1rem;
  line-height: 20px;
  list-style: none;
  padding: 6px 16px;
  position: relative;
  transition: background-color 0.2s cubic-bezier(0.3, 0, 0.5, 1);
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: middle;
  white-space: nowrap;
  word-wrap: break-word;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.button:hover {
  background-color: #f3f4f6;
  text-decoration: none;
  transition-duration: 0.5s;
  transform: scale(1.05);
}

.button:disabled {
  background-color: #fafbfc;
  border-color: rgba(27, 31, 35, 0.15);
  color: #959da5;
  cursor: default;
}

.button:active {
  background-color: #edeff2;
  box-shadow: rgba(225, 228, 232, 0.2) 0 1px 0 inset;
  transition: none 0s;
}

.button:focus {
  outline: 1px transparent;
}

.button:before {
  display: none;
}

.button:-webkit-details-marker {
  display: none;
}

/* fonts */

/* WixMadeforDisplay */
@font-face {
  font-family: "WMFD-Bold";
  src: local("WixMadeforDisplay"), url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-weight: bold;
}

@font-face {
  font-family: "WMFD-SemiBold";
  src: local("WixMadeforDisplay"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
  font-weight: bold;
}

@font-face {
  font-family: "WMFD-ExtraBold";
  src: local("WixMadeforDisplay"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
  font-weight: bold;
}

@font-face {
  font-family: "WMFD-Medium";
  src: local("WixMadeforDisplay"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
  font-weight: bold;
}

@font-face {
  font-family: "WMFD-Regular";
  src: local("WixMadeforDisplay"), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype");
  font-weight: normal;
}

/*WixMadeforText */

@font-face {
  font-family: "WMFT-Bold";
  src: local("WixMadeforText"), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("truetype");
  font-weight: bold;
}

@font-face {
  font-family: "WMFT-ExtraBold";
  src: local("WixMadeforText"), url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("truetype");
  font-weight: bold;
}

@font-face {
  font-family: "WMFT-BoldItalic";
  src: local("WixMadeforText"), url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("truetype");
  font-weight: bold;
}

@font-face {
  font-family: "WMFT-ExtraBoldItalic";
  src: local("WixMadeforText"), url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("truetype");
  font-weight: bold;
}

@font-face {
  font-family: "WMFT-Italic";
  src: local("WixMadeforText"), url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("truetype");
  font-weight: bold;
}

@font-face {
  font-family: "WMFT-Medium";
  src: local("WixMadeforText"), url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("truetype");
  font-weight: bold;
}

@font-face {
  font-family: "WMFT-MediumItalic";
  src: local("WixMadeforText"), url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("truetype");
  font-weight: bold;
}

@font-face {
  font-family: "WMFT-Regular";
  src: local("WixMadeforText"), url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format("truetype");
  font-weight: bold;
}

@font-face {
  font-family: "WMFT-SemiBold";
  src: local("WixMadeforText"), url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format("truetype");
  font-weight: bold;
}

@font-face {
  font-family: "WMFT-SemiBoldItalic";
  src: local("WixMadeforText"), url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format("truetype");
  font-weight: bold;
}

/* Text */
p {
  font-family: "WMFT-Regular";
  font-size: 1rem;
}

h1 {
  font-family: "WMFT-SemiBold";
  text-transform: capitalize;
  letter-spacing: 2px;
  text-align: center;
  color: var(--secondary-color);
}

h3 {
  font-family: "WMFT-Regular";
  font-size: 1.5rem;
  text-align: center;
  line-height: 2.5rem;
}

@media (min-width: 769px) {
  p {
    font-size: 1rem;
  }
  h1 {
    font-size: 2.5rem;
  }
  h3 {
    font-size: 1.5rem;
  }
}

@media (max-width: 768px) {
  p {
    font-size: 1rem;
  }
  h1 {
    font-size: 1.5rem;
  }
  h3 {
    font-size: 1.25rem;
  }
}

@media (max-width: 425px) {
  p {
    font-size: 1rem;
  }
  h1 {
    font-size: 1.25rem;
  }
  h3 {
    font-size: 1.15rem;
  }
}
/* Major elements */

.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: 0.5s ease-in-out;
  transition-property: transform;
  padding-bottom: 4rem;
  width: 100%;
}

.container a:not(.button) {
  border-bottom: solid 1px;
}

.section {
  display: flex;
  flex-direction: column;
  width: 60%;
  padding-bottom: 3rem;
  border-bottom: 1px solid lightgrey;
  align-items: center;
}

.wide-section {
  display: flex;
  flex-direction: column;
  width: 90%;
  padding-bottom: 3rem;
  border-bottom: 1px solid lightgrey;
  align-items: center;
}
/* Images */

.image-default {
  border-radius: 1.5rem;
  width: 50%;
  height: auto;
  margin: 1rem 0rem;
}

.image-3rd {
  border-radius: 1.5rem;
  width: 30%;
  height: auto;
  margin: 1rem 0rem;
}

.image-default-large {
  border-radius: 2rem;
  flex: 1 1;
  width: 80%;
  height: auto;
}

.image-event {
  border-radius: 2rem;
  flex: 1 1;
  width: 80%;
  height: auto;
  cursor: pointer;
}

.image-default-container {
  margin: 2rem 0rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.image-3rd-container {
  margin: 2rem 0rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 1rem;
}

@media (max-width: 1200px) {
  .image-default {
    width: 70%;
  }

  .section {
    width: 80%;
  }

  .wide-section {
    width: 90%;
  }
}

@media (max-width: 768px) {
  .image-3rd-container {
    flex-direction: column;
  }

  .image-3rd {
    width: 100%;
  }
  .image-default {
    width: 100%;
  }

  .image-default-large {
    width: 100%;
  }

  .section {
    width: 90%;
  }
}

@media (max-width: 425px) {
}

/* Animations */

@keyframes grow {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.1);
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB,EAAE,qBAAqB;AAC5C;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,yBAAyB;EACzB,4BAA4B;EAC5B,6BAA6B;EAC7B,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,8JAA8J;EAC9J,mCAAmC;EACnC,kCAAkC;EAClC,uBAAuB;EACvB,mCAAmC;AACrC;;AAEA;EACE,+EAA+E;AACjF;;AAEA,YAAY;;AAEZ;EACE,gBAAgB;EAChB,yBAAyB;EACzB,wCAAwC;EACxC,kBAAkB;EAClB,mFAAmF;EACnF,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,wBAAwB;EACxB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,8DAA8D;EAC9D,iBAAiB;EACjB,yBAAyB;EACzB,0BAA0B;EAC1B,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,kDAAkD;EAClD,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA,UAAU;;AAEV,sBAAsB;AACtB;EACE,wBAAwB;EACxB,2FAA+G;EAC/G,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,2FAAmH;EACnH,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,2FAAoH;EACpH,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,2FAAiH;EACjH,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,2FAAkH;EAClH,mBAAmB;AACrB;;AAEA,kBAAkB;;AAElB;EACE,wBAAwB;EACxB,wFAAsG;EACtG,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,wFAA2G;EAC3G,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,wFAA4G;EAC5G,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;EACnC,wFAAiH;EACjH,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,wFAAwG;EACxG,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,yFAAwG;EACxG,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,yFAA8G;EAC9G,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,yFAAyG;EACzG,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,yFAA0G;EAC1G,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,yFAAgH;EAChH,iBAAiB;AACnB;;AAEA,SAAS;AACT;EACE,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;AACF;AACA,mBAAmB;;AAEnB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;EAC5B,8BAA8B;EAC9B,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,oBAAoB;EACpB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,oBAAoB;EACpB,kCAAkC;EAClC,mBAAmB;AACrB;AACA,WAAW;;AAEX;EACE,qBAAqB;EACrB,UAAU;EACV,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,SAAO;EACP,UAAU;EACV,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,SAAO;EACP,UAAU;EACV,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;AACA;;AAEA,eAAe;;AAEf;EACE;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css?family=Wix+Madefor+Display\");\n\nhtml {\n  scroll-behavior: smooth;\n  box-sizing: border-box;\n  letter-spacing: 1px; /* originally 2.4px */\n}\n\np {\n  line-height: 2rem;\n}\n#root {\n  overflow-x: hidden;\n}\n\n:root {\n  --primary-color: #ff8335;\n  --secondary-color: #006d77;\n  --tertiary-color: #83c5be;\n  --light-primary-color: white;\n  --dark-primary-color: #3d3d3d;\n  --text-color: black;\n  --tablet-width: 768px;\n  --mobile-width: 425px;\n}\n\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: white;\n  font-family: \"Wix Made For Display\";\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\", monospace;\n}\n\n/* buttons */\n\n.button {\n  appearance: none;\n  background-color: #fafbfc;\n  border: 1px solid rgba(27, 31, 35, 0.15);\n  border-radius: 6px;\n  box-shadow: rgba(27, 31, 35, 0.04) 0 1px 0, rgba(255, 255, 255, 0.25) 0 1px 0 inset;\n  box-sizing: border-box;\n  color: black;\n  cursor: pointer;\n  display: inline-block;\n  font-family: \"WMFD-Bold\";\n  font-size: 1rem;\n  line-height: 20px;\n  list-style: none;\n  padding: 6px 16px;\n  position: relative;\n  transition: background-color 0.2s cubic-bezier(0.3, 0, 0.5, 1);\n  user-select: none;\n  -webkit-user-select: none;\n  touch-action: manipulation;\n  vertical-align: middle;\n  white-space: nowrap;\n  word-wrap: break-word;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n}\n\n.button:hover {\n  background-color: #f3f4f6;\n  text-decoration: none;\n  transition-duration: 0.5s;\n  transform: scale(1.05);\n}\n\n.button:disabled {\n  background-color: #fafbfc;\n  border-color: rgba(27, 31, 35, 0.15);\n  color: #959da5;\n  cursor: default;\n}\n\n.button:active {\n  background-color: #edeff2;\n  box-shadow: rgba(225, 228, 232, 0.2) 0 1px 0 inset;\n  transition: none 0s;\n}\n\n.button:focus {\n  outline: 1px transparent;\n}\n\n.button:before {\n  display: none;\n}\n\n.button:-webkit-details-marker {\n  display: none;\n}\n\n/* fonts */\n\n/* WixMadeforDisplay */\n@font-face {\n  font-family: \"WMFD-Bold\";\n  src: local(\"WixMadeforDisplay\"), url(\"./fonts/WixMadeforDisplay/WixMadeforDisplay-Bold.ttf\") format(\"truetype\");\n  font-weight: bold;\n}\n\n@font-face {\n  font-family: \"WMFD-SemiBold\";\n  src: local(\"WixMadeforDisplay\"), url(\"./fonts/WixMadeforDisplay/WixMadeforDisplay-SemiBold.ttf\") format(\"truetype\");\n  font-weight: bold;\n}\n\n@font-face {\n  font-family: \"WMFD-ExtraBold\";\n  src: local(\"WixMadeforDisplay\"), url(\"./fonts/WixMadeforDisplay/WixMadeforDisplay-ExtraBold.ttf\") format(\"truetype\");\n  font-weight: bold;\n}\n\n@font-face {\n  font-family: \"WMFD-Medium\";\n  src: local(\"WixMadeforDisplay\"), url(\"./fonts/WixMadeforDisplay/WixMadeforDisplay-Medium.ttf\") format(\"truetype\");\n  font-weight: bold;\n}\n\n@font-face {\n  font-family: \"WMFD-Regular\";\n  src: local(\"WixMadeforDisplay\"), url(\"./fonts/WixMadeforDisplay/WixMadeforDisplay-Regular.ttf\") format(\"truetype\");\n  font-weight: normal;\n}\n\n/*WixMadeforText */\n\n@font-face {\n  font-family: \"WMFT-Bold\";\n  src: local(\"WixMadeforText\"), url(\"./fonts/WixMadeforText/WixMadeforText-Bold.ttf\") format(\"truetype\");\n  font-weight: bold;\n}\n\n@font-face {\n  font-family: \"WMFT-ExtraBold\";\n  src: local(\"WixMadeforText\"), url(\"./fonts/WixMadeforText/WixMadeforText-ExtraBold.ttf\") format(\"truetype\");\n  font-weight: bold;\n}\n\n@font-face {\n  font-family: \"WMFT-BoldItalic\";\n  src: local(\"WixMadeforText\"), url(\"./fonts/WixMadeforText/WixMadeforText-BoldItalic.ttf\") format(\"truetype\");\n  font-weight: bold;\n}\n\n@font-face {\n  font-family: \"WMFT-ExtraBoldItalic\";\n  src: local(\"WixMadeforText\"), url(\"./fonts/WixMadeforText/WixMadeforText-ExtraBoldItalic.ttf\") format(\"truetype\");\n  font-weight: bold;\n}\n\n@font-face {\n  font-family: \"WMFT-Italic\";\n  src: local(\"WixMadeforText\"), url(\"./fonts/WixMadeforText/WixMadeforText-Italic.ttf\") format(\"truetype\");\n  font-weight: bold;\n}\n\n@font-face {\n  font-family: \"WMFT-Medium\";\n  src: local(\"WixMadeforText\"), url(\"./fonts/WixMadeforText/WixMadeforText-Medium.ttf\") format(\"truetype\");\n  font-weight: bold;\n}\n\n@font-face {\n  font-family: \"WMFT-MediumItalic\";\n  src: local(\"WixMadeforText\"), url(\"./fonts/WixMadeforText/WixMadeforText-MediumItalic.ttf\") format(\"truetype\");\n  font-weight: bold;\n}\n\n@font-face {\n  font-family: \"WMFT-Regular\";\n  src: local(\"WixMadeforText\"), url(\"./fonts/WixMadeforText/WixMadeforText-Regular.ttf\") format(\"truetype\");\n  font-weight: bold;\n}\n\n@font-face {\n  font-family: \"WMFT-SemiBold\";\n  src: local(\"WixMadeforText\"), url(\"./fonts/WixMadeforText/WixMadeforText-SemiBold.ttf\") format(\"truetype\");\n  font-weight: bold;\n}\n\n@font-face {\n  font-family: \"WMFT-SemiBoldItalic\";\n  src: local(\"WixMadeforText\"), url(\"./fonts/WixMadeforText/WixMadeforText-SemiBoldItalic.ttf\") format(\"truetype\");\n  font-weight: bold;\n}\n\n/* Text */\np {\n  font-family: \"WMFT-Regular\";\n  font-size: 1rem;\n}\n\nh1 {\n  font-family: \"WMFT-SemiBold\";\n  text-transform: capitalize;\n  letter-spacing: 2px;\n  text-align: center;\n  color: var(--secondary-color);\n}\n\nh3 {\n  font-family: \"WMFT-Regular\";\n  font-size: 1.5rem;\n  text-align: center;\n  line-height: 2.5rem;\n}\n\n@media (min-width: 769px) {\n  p {\n    font-size: 1rem;\n  }\n  h1 {\n    font-size: 2.5rem;\n  }\n  h3 {\n    font-size: 1.5rem;\n  }\n}\n\n@media (max-width: 768px) {\n  p {\n    font-size: 1rem;\n  }\n  h1 {\n    font-size: 1.5rem;\n  }\n  h3 {\n    font-size: 1.25rem;\n  }\n}\n\n@media (max-width: 425px) {\n  p {\n    font-size: 1rem;\n  }\n  h1 {\n    font-size: 1.25rem;\n  }\n  h3 {\n    font-size: 1.15rem;\n  }\n}\n/* Major elements */\n\n.container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  transition: 0.5s ease-in-out;\n  transition-property: transform;\n  padding-bottom: 4rem;\n  width: 100%;\n}\n\n.container a:not(.button) {\n  border-bottom: solid 1px;\n}\n\n.section {\n  display: flex;\n  flex-direction: column;\n  width: 60%;\n  padding-bottom: 3rem;\n  border-bottom: 1px solid lightgrey;\n  align-items: center;\n}\n\n.wide-section {\n  display: flex;\n  flex-direction: column;\n  width: 90%;\n  padding-bottom: 3rem;\n  border-bottom: 1px solid lightgrey;\n  align-items: center;\n}\n/* Images */\n\n.image-default {\n  border-radius: 1.5rem;\n  width: 50%;\n  height: auto;\n  margin: 1rem 0rem;\n}\n\n.image-3rd {\n  border-radius: 1.5rem;\n  width: 30%;\n  height: auto;\n  margin: 1rem 0rem;\n}\n\n.image-default-large {\n  border-radius: 2rem;\n  flex: 1;\n  width: 80%;\n  height: auto;\n}\n\n.image-event {\n  border-radius: 2rem;\n  flex: 1;\n  width: 80%;\n  height: auto;\n  cursor: pointer;\n}\n\n.image-default-container {\n  margin: 2rem 0rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.image-3rd-container {\n  margin: 2rem 0rem;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  gap: 1rem;\n}\n\n@media (max-width: 1200px) {\n  .image-default {\n    width: 70%;\n  }\n\n  .section {\n    width: 80%;\n  }\n\n  .wide-section {\n    width: 90%;\n  }\n}\n\n@media (max-width: 768px) {\n  .image-3rd-container {\n    flex-direction: column;\n  }\n\n  .image-3rd {\n    width: 100%;\n  }\n  .image-default {\n    width: 100%;\n  }\n\n  .image-default-large {\n    width: 100%;\n  }\n\n  .section {\n    width: 90%;\n  }\n}\n\n@media (max-width: 425px) {\n}\n\n/* Animations */\n\n@keyframes grow {\n  0% {\n    transform: scale(1);\n  }\n  100% {\n    transform: scale(1.1);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
